/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-template[_ngcontent-%COMP%]{padding:60px 15px;text-align:center}.error-actions[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}.error-actions[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-right:10px}@media screen and (max-width:406px){.error-actions[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-top:10px}}"];
export { styles as styles };
